import { render, staticRenderFns } from "./VisualizarPedidoDeCompraModal.vue?vue&type=template&id=0fb4d90e&scoped=true"
import script from "./VisualizarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VisualizarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VisualizarPedidoDeCompraModal.vue?vue&type=style&index=0&id=0fb4d90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb4d90e",
  null
  
)

export default component.exports